import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import CAxios from "../utils/CAxios";

//GET Participant details
export const getParticipantDetails = createAsyncThunk<AxiosResponse<any, any>>(
  "participants/getParticipantDetails",
  async () => {
    try {
      let response = await CAxios.get(`profile/details`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
//GET Share details
export const getShareDetails = createAsyncThunk<
  any,
  {
    participant_id?: number | null;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("participants/getShareDetails", async (data) => {
  try {
    let response = await CAxios.post(`share/details`, data);
    return response?.data?.result ?? response?.data;
  } catch (error) {
    throw error;
  }
});
//GET Participant photos (grouped by name)
export const getParticipantPhotos = createAsyncThunk<
  any,
  {
    participant_id?: number | null;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("participants/getParticipantPhotos", async (data) => {
  try {
    let response = await CAxios.post(`participant/photos`, data);
    return response?.data?.result ?? response?.data;
  } catch (error) {
    throw error;
  }
});
//GET Participant videos (grouped by name)
export const getParticipantVideos = createAsyncThunk<
  any,
  {
    participant_id?: number | null;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("participants/getParticipantVideos", async (data) => {
  try {
    let response = await CAxios.post(`participant/videos`, data);
    return response?.data?.result ?? response?.data;
  } catch (error) {
    throw error;
  }
});
//GET Participant donations
export const getParticipantDonations = createAsyncThunk<
  any,
  {
    participant_id?: number | null;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("participants/getParticipantDonations", async (data) => {
  try {
    let response = await CAxios.post(`participant/donations`, data);
    return response?.data?.result ?? response?.data;
  } catch (error) {
    throw error;
  }
});
